import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import swal from "sweetalert";

import commoncss from "../../myfin_v2/css/common.module.css";
import tablecss from "../../myfin_v2/css/table.module.css";
import GroupingDrilldownTable from "./GroupingDrilldownTable"


const PNLStatement = (props) => {
  const { plData, selectedL1, selectedL2, setExternalSelection, onDrop, refreshMappingData, onAfterDrop, currentYear, previousYear } = props;
  const scrollRef = useRef(null);



  return (
    <>
      {!plData ? (
        <div
          className={tablecss.tableContainer} style={{ height: "-webkit-available", overflowY: "auto" }}
        >
          <Spinner animation="grow" size="sm" />
          <Spinner animation="grow" style={{ margin: "1rem" }} />
          <Spinner animation="grow" size="sm" />
        </div>
      ) : (
        <div ref={scrollRef} style={{ flex: 1, height: "100%", overflow: "hidden" }} >
          {plData && (
            <GroupingDrilldownTable grouping={plData}
              category="PL"
              currentYear={currentYear}
              previousYear={previousYear}
              selectedL1={selectedL1}
              selectedL2={selectedL2}
              setExternalSelection={setExternalSelection}
              containerRef={scrollRef}
              onDrop={onDrop}
              refreshMappingData={refreshMappingData}
              onAfterDrop={onAfterDrop}
              setUpdateTabs={props.setUpdateTabs} />
          )}
        </div>
      )
      }
    </>
  );
};

export default PNLStatement;
